/*
 * 导入的文件
 * 此项目同时兼容电脑端和移动端项目，移动端框架优先使用MintUI，pc端优先使用ElementUI
 * @Vue： vue
 * @App: 入口vue
 * @VueRouter: 路由文件
 * @VueLazyload：懒加载
 * @MintUI 前端组件
 * @axios ajax
 * @babel-polyfill 现代浏览器支持es6
 * @Mint 基于 Vue.js 的移动端组件库
 * */
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import qs from 'qs'
import store from './store/index'
import 'babel-polyfill'
import VueLazyload from 'vue-lazyload'
import MintUI from 'mint-ui';
import ElementUI from 'element-ui' //继承element

Vue.use(MintUI);
Vue.use(ElementUI)

//懒加载
Vue.use(VueLazyload, {
  preLoad: 1.3,
//error: require('img/leslie.jpg'),
//loading: require('img/chuan.jpg'),
  attempt: 1
})

//通用样式表
require('!style-loader!css-loader!less-loader!assets/css/mint.min.css');
require('!style-loader!css-loader!less-loader!./assets/less/style.less');
require('!style-loader!css-loader!less-loader!element-ui/lib/theme-chalk/index.css');

require("es6-promise").polyfill();
//关闭生产时的警告
Vue.config.productionTip = false
//Vue.mixin(ajax)    //注册成为共同组件方法

//axios.defaults.headers.common['Authorization'] = 'AUTH_TOKEN';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.headers.post['token'] = '1008611';

Vue.prototype.$ajax= axios
Vue.prototype.$qs = qs;

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js